import { render, staticRenderFns } from "./SinglePointGoalInput.vue?vue&type=template&id=15e42ae9&scoped=true&"
import script from "./SinglePointGoalInput.vue?vue&type=script&lang=ts&"
export * from "./SinglePointGoalInput.vue?vue&type=script&lang=ts&"
import style0 from "./SinglePointGoalInput.vue?vue&type=style&index=0&id=15e42ae9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e42ae9",
  null
  
)

export default component.exports